/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromoCodeDto } from '../../models/promo-code-dto';

export interface GetPromoCodeByName$Params {
  name: string;
}

export function getPromoCodeByName(http: HttpClient, rootUrl: string, params: GetPromoCodeByName$Params, context?: HttpContext): Observable<StrictHttpResponse<PromoCodeDto>> {
  const rb = new RequestBuilder(rootUrl, getPromoCodeByName.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromoCodeDto>;
    })
  );
}

getPromoCodeByName.PATH = '/api/v1/promo-codes/{name}';
